import { create } from 'zustand';

interface SendEssayState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
  setIsLoading: (loading: boolean) => void;
  setIsSuccess: (status: boolean) => void;
  setIsError: (error: boolean) => void; 
  setErrorMessage: (message: string | null) => void;
  resetSendEssay: () => void;
}

export const useSendEssayStore = create<SendEssayState>((set) => ({
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: null,
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  setIsSuccess: (status: boolean) => set({ isSuccess: status }),
  setIsError: (error: boolean) => set({ isError: error }),
  setErrorMessage: (message: string | null) => set({ errorMessage: message }),
  resetSendEssay: () => set({
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null,
  })
}));
